import React, { useEffect, useState } from 'react';
import PodcastForm from '../PodcastForm/Container'

import { Uploader, UploadField } from '@navjobs/upload'
import {serverUrl} from '../../utils/restUtils'
import {Link} from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import Modal from '../Modal'
import Share from '../Share'
import './podcasts.css'


export default  ({podcasts, loadPodcasts, authenticated, removePodcast, match}) =>  {  
    
    useEffect(() => {
	loadPodcasts()
    }, []);
    
    const [modalVisible, toggleModal] = useState(null)
    const [showPodcast, setShowPodcast] = useState(null)

    useEffect(() => {
	if(match.params.id!=undefined && showPodcast == undefined && podcasts.length > 0){
	    setShowPodcast(podcasts.filter(p => p.id == match.params.id)[0])
	}
    }, [podcasts]);

    useEffect(() => {
	window.history.pushState('Radijski oder', 'Radijski oder', `/podcasts/${(showPodcast == null || showPodcast.id == null ? '' : showPodcast.id)}`)
    }, [showPodcast]);


    
    return (
	<div>
	    <h1>Beseda ne zaspi</h1>
	    { authenticated &&
	      <button className="btn btn-brown btn-big full-width" onClick={() => toggleModal({})}><i className="fa fa-plus"></i> Dodaj podcast</button>}


	    <div className="podcasts">
		{podcasts.map(a => <div key={a.id} className="podcastLink">
		    {authenticated  &&
		     <Uploader
			 request={{
			     fileName: 'file',
			     url: serverUrl()+'/podcasts/'+a.id+'/upload',
			     method: 'PUT',
			     withCredentials: true
			 }}
			 onComplete={({ response, status }) => {
			     loadPodcasts()
			 }}
			 uploadOnSelection={true}
		     >
			 {({ onFiles, progress, complete }) => (
			     <div className="adminSection">
				 <ReactTooltip />
				 
				 {<button style={{float: 'left'}}  data-tip="Spremeni"  className="btn" onClick={() => toggleModal(a)}><i className="fa fa-edit"></i></button>}
				 {<button style={{float: 'right'}} data-tip="Zbriši"  className="btn" onClick={()=>removePodcast(a.id)}><i className="fa fa-remove"></i></button>}
				 
				 <div  style={{float: 'left'}} data-tip="Dodaj ali menjaj audio">
				     <UploadField onFiles={files => {
					 if(Array.from(files).map(f => f.size>200*1024*1024 ).filter(x => x ).length === 0)
					     onFiles(files)
					 else
					     alert('preveč velik file, max 200MB')
				     } }  uploadProps={{ accept: '.mp3'}}>
					 <button className="btn">
					     <i className="fa fa-podcast"></i>
					 </button>
				     </UploadField>
				 </div>


				 <div  style={{float: 'left'}} data-tip="Dodaj ali menjaj sliko">
				     <UploadField onFiles={files => {
					 if(Array.from(files).map(f => f.size>100*1024*1024 ).filter(x => x ).length === 0)
					     onFiles(files)
					 else
					     alert('preveč velik file, max 100MB')
				     } }  uploadProps={{ accept: '.png,.jpg,.jpeg,.svg,.gif'}}>
					 <button className="btn">
					     <i className="fa fa-camera"></i>
					 </button>
				     </UploadField>
				 </div>
				 <div style={{clear: 'both'}}></div>
				 {!complete && progress  &&
				  <div className="progressBar">
				      <div style={{width: progress+'%'}}></div>
				  </div>
				 }

			     </div>
			 )}
		     </Uploader>
		    }
		    <button className="btn nopadding" onClick={() =>  setShowPodcast(a)}>
			
			<img src={a.image_id != null ? serverUrl()+'/images/'+a.image_id : "/images/podcast_img.jpg"} />
			<div className="title">{a.title}</div>
		    </button>
		</div>)}
	    </div>
	    
	    <Modal toggleModal={() => setShowPodcast(false)} visible={showPodcast}>
		{showPodcast &&
		 <React.Fragment>
		     <h2>{showPodcast.title}</h2>
		     <p>{showPodcast.description}</p>
		     <img src="/images/podcast_animated.gif" style={{width: '100%'}} />
		     <div style={{marginTop: '30px'}}>
			 <audio controls style={{width: '100%'}}>
			     <source src={serverUrl()+'/podcasts/'+showPodcast.id} type="audio/mpeg" />
			 </audio>
		     </div>
		     <hr style={{borderTop: '1px solid black'}} />
		     <Share title={showPodcast.title} url={`http://radijskioder.com/podcasts/${showPodcast.id}`} />
		 </React.Fragment>
		}
	    </Modal>
	    
	    <Modal toggleModal={() => toggleModal(false)} visible={modalVisible}>
		<h2>Dodaj album</h2>
		<PodcastForm successAction={toggleModal}  initialValues={modalVisible} />
	    </Modal>
	</div>
    );
    
}



// WEBPACK FOOTER //
// ./src/components/Podcasts/index.jsx